module.exports = __webpack_public_path__ + "img/preteen-boy-uses-laptop-make-online-classes-saying-hello-teacher.37f56e31.jpg";